export default {
  cpu: {
    value: 1,
    growthRate: 1,
    minValue: 1,
    maxValue: 1000,
    unit: "هسته",
    pricePerUnit: 100
  },
  ram: {
    value: 1,
    growthRate: 1,
    minValue: 1,
    maxValue: 1000,
    unit: "گیگابایت",
    pricePerUnit: 100
  },
  storage: {
    value: 1,
    growthRate: 1,
    minValue: 1,
    maxValue: 1000,
    unit: "گیگابایت",
    pricePerUnit: 100
  },
  loading: false,
  showError: false,
  errorMessages: []
};
